.sidebar {
  grid-area: sidebar;
  display: none;
}
.sidebar .infoContainer {
  display: none;
}
@media screen and (min-width: 801px) {
  .sidebar {
    display: flex;
    flex-direction: column;
    gap: var(--cxy-spacing-4) 0;
    padding-inline-start: var(--cxy-spacing-4);
    padding-inline-end: var(--cxy-spacing-3);
    color: var(--cxy-color-content-default);
    align-self: start;
    position: sticky;
    top: 82px;
    max-height: calc(100vh - 82px - var(--cxy-spacing-4));
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  .sidebar::-webkit-scrollbar-track {
    background: var(--cxy-color-border-default);
  }
  .sidebar::-webkit-scrollbar-track:hover {
    background-color: var(--cxy-color-border-hover);
  }
  .sidebar .infoContainer {
    display: block;
  }
}
.sidebar [data-testid='sortby-dropdown'] > label {
  font-size: var(--cxy-fontSize-xl);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-content-default);
}

.sorting {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-4);
}
.sorting h2 {
  color: var(--cxy-color-content-default);
  padding: var(--cxy-spacing-2) 0;
  padding-block-start: 0;
  font-size: var(--cxy-fontSize-xl);
  font-weight: var(--cxy-fontWeight-bold);
}
@media (max-width: 801px) {
  .sorting {
    margin-block-start: var(--cxy-spacing-2);
    padding: var(--cxy-spacing-4);
  }
}

.infoContainer {
  grid-area: sidebar;
  padding-inline-end: var(--cxy-spacing-4);
  color: var(--cxy-color-content-default);
  padding: var(--cxy-spacing-4);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.infoContainer.compact {
  padding-inline-end: 0;
  padding-inline-start: 0;
}
@media screen and (min-width: 801px) {
  .infoContainer {
    margin-block-end: var(--cxy-spacing-3);
    display: none;
  }
  .infoContainer .availableResults {
    height: 100%;
    padding-block-end: var(--cxy-spacing-4);
    padding-inline-start: var(--cxy-spacing-4);
    display: flex;
    align-items: center;
  }
}

.mobileMenuTrigger {
  display: block;
}
@media screen and (min-width: 801px) {
  .mobileMenuTrigger {
    display: none;
  }
}

.availableResults {
  grid-area: state;
  font-weight: var(--cxy-fontWeight-normal);
  line-height: var(--cxy-lineHeight-xs);
  font-size: var(--cxy-fontSize-m);
}
@media screen and (min-width: 801px) {
  .availableResults {
    font-size: var(--cxy-fontSize-l);
    height: 48px;
    display: flex;
    align-items: center;
  }
}
